<template>
  <div>
    <nav-bar></nav-bar>
    <section class="resturant-main tab-content header-top">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <home-title :title="brandname" subtitle=""></home-title>
            <div :class="'resturant-item-main' + (webVendorListingLayout == '1' ? '' : webVendorListingLayout)"
              id="resturant-item-main" v-if="items && items.length > 0">
              <item v-for="item in items" :key="item.name" :item="item"
                :currencys="$auth.setting && $auth.setting.currency" :isPickupDelivery="filter.is_pickup_delivery"
                :isSchedule="$auth.setting && $auth.setting.is_enable_schedule_order_after_business_hours"
                :webVendorLayout="webVendorListingLayout" components=""></item>
            </div>
            <div v-else class="order-offers rest-not-found">
              <div class="text-center my-2" v-if="loading">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <p v-else>{{ $t('No Restaurants Found') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeTitle from "@/components/HomeTitle.vue";
import NavBar from "@/components/NavBar.vue";
import Item from "@/components/Item.vue";
import { mapActions, mapGetters } from "vuex";
import Footer from '../components/Footer.vue';

export default {
  name: "BrandItems",
  components: {
    HomeTitle,
    NavBar,
    Item,
    Footer
  },
  data() {
    return {
      items: [],
      currencys: "",
      loading: true,
      setting: {},
      filter: {
        lat: "",
        lng: "",
        city: "",
        state: "",
        is_pickup_delivery: 1,
      },
      skip: 0,
      isStopCallingApi: false,
      webVendorListingLayout: '',
      brandname: localStorage.getItem("brandname")
    };
  },
  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),
  },
  mounted() {
    setTimeout(() => {
      this.webVendorListingLayout = this.$auth.setting.vendor_listing_layout;
      if (this.webVendorListingLayout == '') {
        this.webVendorListingLayout = 1;
      }
    }, 1000);
    this.getRestaurant();
  },
  methods: {
    ...mapActions("restaurant", ["getBrandRestaurants"]),

    //Get All banner Restaurant
    getRestaurant() {
      this.loading = true;
      let restData = {
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        brand_id: this.base64_decode(this.$route.params.brand_id),
        skip: 0,
        delivery_type_time_slots: this.isPickupDelivery,
        latitude: parseFloat(localStorage.getItem("latitude")),
        longitude: parseFloat(localStorage.getItem("longitude"))
      };
      this.getBrandRestaurants(restData).then((data) => {
        this.loading = true;
        if (data.code == 200) {
          this.loading = false;
          this.skip = data.open_restaurant;
          if (!this.items.length) {
            data.Result.forEach((resItem) => {
              this.items.push(resItem);
            });
          } else {
            data.Result.forEach((resItem) => {
              let checkRest = this.items.find((elm) => elm.restaurant_id == resItem.restaurant_id);
              if (!checkRest) {
                this.items.push(resItem);
              }
            });
          }
        } else {
          if (data.Result.length == 0) {
            this.loading = false;
            this.isStopCallingApi = true;
          }
        }
      });
    },
  },
};
</script>
